import React from "react";

export default function IconCheckedSuccess() {
  return (
    <span className="ico-success-background">
      <i className="far fa-check" title='icon-success'/>
    </span>
  );
}